import { getCurrentUser } from 'aws-amplify/auth';
import { type ReactElement, type ReactNode, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface RequireAuthProps {
  children: ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps): ReactElement | null {
  const navigate = useNavigate();
  const [isAuth, setIsAuth] = useState<boolean | null>(null);
  useEffect(() => {
    getCurrentUser()
      .then(() => setIsAuth(true))
      .catch(() => {
        navigate('/signin');
      });
  }, [navigate]);
  if (isAuth === null) {
    return null;
  }

  return isAuth ? <>{children}</> : null;
}
